import React from 'react';
import COPY from './copy.json';

/*
 * Chrome bersama situs publik: header, footer, sticky call bar, ikon, helper t().
 *
 * Diekstrak saat halaman KEDUA (Services) benar-benar membutuhkannya — bukan
 * sebelumnya. Selama hanya home yang memakainya, memecahnya tidak menambah apa
 * pun.
 */

/*
 * Timpaan teks dari dashboard (tabel SiteCopy), diisi oleh loadSiteCopy() di
 * setiap route action publik.
 *
 * Sengaja variabel modul, bukan prop yang dijalarkan ke 12 halaman: isinya SAMA
 * untuk semua pengunjung — teks situs, bukan data per-pengguna — jadi tidak ada
 * yang bisa bocor antar-request kalau dua request diproses bersamaan. Prop akan
 * berarti menyentuh setiap komponen hanya untuk mengangkut nilai yang identik.
 */
let OVERRIDE = {};
export const setSiteCopy = map => { OVERRIDE = map || {}; };

// Teks diambil dari copy.json, kecuali kalau dashboard menimpanya. Kunci yang
// belum diterjemahkan otomatis jatuh ke en-US, jadi bahasa Arab boleh dicicil
// sebagian tanpa merusak halaman — berlaku untuk bawaan maupun timpaan.
export const t = (locale, key, vars) => {
  let str = (OVERRIDE[locale] && OVERRIDE[locale][key])
    || (OVERRIDE['en-US'] && OVERRIDE['en-US'][key])
    || (COPY[locale] && COPY[locale][key])
    || COPY['en-US'][key]
    || key;
  if (vars) Object.keys(vars).forEach(k => { str = str.replace('{' + k + '}', vars[k]); });
  return str;
};

/*
 * Nama dasar berkas figure. Bawaan = nama slot itu sendiri ('home' →
 * /images/site/home-1600.webp). Kalau client mengunggah gambar baru dari
 * dashboard, SiteCopy menyimpan nama acak hasil unggah dan URL-nya tetap
 * berbentuk sama — cuma dilayani dari images/site/ alih-alih public/images/site/.
 */
export const figureName = slot => {
  const o = OVERRIDE['en-US'] && OVERRIDE['en-US']['figure.' + slot];
  return o || slot;
};

export const PHONE = '+971505052213';
// U+2066 LRI … U+2069 PDI mengisolasi nomor sebagai LTR. Tanpa ini, dalam
// konteks RTL browser membalik urutan kelompok digit dan "050 505 2213"
// terbaca "2213 505 050" — nomor telepon yang salah di situs darurat.
// Hanya untuk TAMPILAN; href tel: memakai PHONE yang tetap bersih.
export const PHONE_LABEL = '\u2066050 505 2213\u2069';
export const WA = 'https://wa.me/971505052213';

export const IconPhone = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M21 16.9v2.5a1.6 1.6 0 0 1-1.8 1.6 16 16 0 0 1-7-2.5 15.7 15.7 0 0 1-4.8-4.8 16 16 0 0 1-2.5-7.1A1.6 1.6 0 0 1 6.5 4.7H9a1.6 1.6 0 0 1 1.6 1.4c.1.8.3 1.5.6 2.2a1.6 1.6 0 0 1-.4 1.7l-1 1a12.9 12.9 0 0 0 4.8 4.8l1-1a1.6 1.6 0 0 1 1.7-.4c.7.3 1.4.5 2.2.6A1.6 1.6 0 0 1 21 16.9Z" /></svg>
);
export const IconWa = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 2a10 10 0 0 0-8.5 15.2L2 22l4.9-1.4A10 10 0 1 0 12 2Zm5.1 14c-.2.6-1.2 1.2-1.7 1.2-.5.1-1 .1-1.7-.1a10 10 0 0 1-3-1.7 11.6 11.6 0 0 1-2.4-3c-.3-.6-.5-1.2-.5-1.8 0-.6.3-1.2.6-1.5.2-.2.4-.3.6-.3h.5c.2 0 .4 0 .5.4l.7 1.7c0 .2 0 .3-.1.5l-.3.4-.3.3c-.1.1-.2.3-.1.5.3.6.8 1.2 1.3 1.6.5.4 1 .7 1.5.9.2.1.4 0 .5-.1l.6-.7c.2-.2.3-.2.5-.1l1.6.8c.4.2.4.4.4.5s0 .8-.2 1.1Z" /></svg>
);
export const IconDownload = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 3v12m0 0 4.5-4.5M12 15l-4.5-4.5M4 17v2.5A1.5 1.5 0 0 0 5.5 21h13a1.5 1.5 0 0 0 1.5-1.5V17" /></svg>
);
export const IconTick = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 12.5l5 5L20 6.5" /></svg>
);
export const IconArrow = () => (
  <svg viewBox="0 0 24 24"><path d="M5 12h14M13 6l6 6-6 6" /></svg>
);
export const IconStore = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M16.4 12.7c0-2.3 1.9-3.4 2-3.5-1.1-1.6-2.8-1.8-3.4-1.8-1.4-.1-2.7.8-3.4.8-.7 0-1.8-.8-3-.8-1.5 0-3 .9-3.8 2.3-1.6 2.8-.4 7 1.2 9.3.8 1.1 1.7 2.3 2.9 2.3 1.2 0 1.6-.7 3-.7 1.4 0 1.8.7 3 .7 1.2 0 2-1.1 2.8-2.2.9-1.3 1.3-2.5 1.3-2.6-.1 0-2.6-1-2.6-3.8ZM14.3 5.4c.6-.8 1-1.9.9-3-1 0-2.2.7-2.9 1.5-.6.7-1.1 1.8-1 2.9 1.1.1 2.3-.6 3-1.4Z" /></svg>
);
export const IconPlay = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3.6 2.4a1.4 1.4 0 0 0-.5 1.1v17a1.4 1.4 0 0 0 .5 1.1l9.1-9.6-9.1-9.6Zm10.2 8.5 2.6-2.7-9.6-5.5 7 8.2Zm0 2.2-7 8.2 9.6-5.5-2.6-2.7Zm4-1.1 2.8-1.6c.6-.3.6-1.2 0-1.6L17.8 7.3l-3 3.2 3 3.2 1.2-.7Z" /></svg>
);

/*
 * Reveal saat scroll — port dari site.js prototipe.
 *
 * Progresif: HTML dari server merender semuanya terlihat, dan elemen baru
 * disembunyikan di sini, setelah JS jalan. Tanpa JS (atau tanpa
 * IntersectionObserver) halaman tetap utuh. Dilewati saat prefers-reduced-motion.
 * Mengembalikan observer agar pemanggil bisa disconnect() saat unmount.
 */
export function initReveal() {
  if (!('IntersectionObserver' in window)) return null;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return null;

  const targets = document.querySelectorAll('.svc, .step, .cov, .trust-item, .tick');
  const EASE = 'cubic-bezier(.2,.75,.2,1)';
  targets.forEach((el, i) => {
    const delay = (i % 6) * 60;
    el.style.opacity = '0';
    el.style.transform = 'translateY(14px)';
    el.style.transition = `opacity .5s ${EASE} ${delay}ms, transform .5s ${EASE} ${delay}ms`;
  });

  const io = new IntersectionObserver(entries => {
    entries.forEach(en => {
      if (!en.isIntersecting) return;
      en.target.style.opacity = '1';
      en.target.style.transform = 'none';
      io.unobserve(en.target);
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });

  targets.forEach(el => io.observe(el));
  return io;
}

/*
 * Logo + nama merek. Dipakai header DAN footer — sebelumnya markupnya disalin
 * di dua tempat, dan penggantian logo cuma mengenai salah satunya.
 *
 * Logo asli Bas Recovery, bukan ikon truk generik. Sumbernya berkas yang sama
 * dengan favicon (PNG 3375 px, 521 KB) — di sini 80/160 px webp, 4 dan 8 KB.
 *
 * Nama merek tetap TEKS di sebelahnya, meski logonya juga memuat tulisan yang
 * sama: pada 44 px tulisan di dalam lingkaran tidak terbaca, dan mesin pencari
 * perlu nama itu sebagai teks, bukan sebagai piksel.
 */
export const BrandLockup = ({ locale }) => (
  [
    <span className="brand-mark" key="m" aria-hidden="true">
      <img src="/images/site/logo-160.webp"
        {...{ srcset: '/images/site/logo-80.webp 80w, /images/site/logo-160.webp 160w' }}
        sizes="44px" alt="" width="44" height="44" />
    </span>,
    <span className="brand-name" key="n">
      {t(locale, 'brand.name')}<small>{t(locale, 'brand.tagline')}</small>
    </span>
  ]
);

// `current` menandai item nav aktif — memberi garis oranye lewat
// .nav a[aria-current] di site.css.
export const Header = ({ locale, navOpen, onToggleNav, onCloseNav, onSwitchLang, current }) => {
  const tx = (k, v) => t(locale, k, v);
  const NAV = [
    ['/', 'nav.home'], ['/service-recovery', 'nav.services'], ['/coverage', 'nav.coverage'],
    ['/providers', 'nav.providers'], ['/about', 'nav.about'], ['/contact', 'nav.contact']
  ];
  return (
    <header className="hdr" data-open={String(navOpen)}>
      <a className="brand" href="/" aria-label={tx('brand.homeAria')}>
        <BrandLockup locale={locale} />
      </a>

      <nav className="nav" aria-label="Main" onClick={onCloseNav}>
        {NAV.map(([href, key]) => (
          <a key={href} href={href} aria-current={href === current ? 'page' : undefined}>{tx(key)}</a>
        ))}
      </nav>

      <div className="hdr-act">
        <button className="lang" type="button" aria-label={tx('nav.switchLangAria')}
          onClick={onSwitchLang}>{tx('nav.switchLang')}</button>
        <a className="btn btn-app" href="/app" aria-label={tx('app.dlAria')}>
          <IconDownload /><span>{tx('app.dl')}</span>
        </a>
        <button className="burger" type="button" aria-label={tx('nav.menu')}
          aria-expanded={String(navOpen)} aria-controls="nav" onClick={onToggleNav}>
          <svg viewBox="0 0 24 24"><path d="M4 7h16M4 12h16M4 17h16" /></svg>
        </button>
      </div>
    </header>
  );
};

export const CallBar = ({ locale }) => (
  <div className="callbar">
    <a className="btn btn-call" href={`tel:${PHONE}`}><IconPhone />{t(locale, 'callbar.call')}</a>
    <a className="btn btn-wa" href={WA} aria-label={t(locale, 'callbar.whatsappAria')}><IconWa /></a>
  </div>
);

export const Footer = ({ locale }) => {
  const tx = (k, v) => t(locale, k, v);
  // Mengikuti katalog asli di DB, bukan lima layanan karangan prototipe:
  // battery dan lockout sebenarnya subkategori di bawah Car Services.
  const SVC = [
    ['/service-recovery', 'ftr.svcRecovery'], ['/service-tyre', 'ftr.svcTyre'],
    ['/service-fuel', 'ftr.svcFuel'], ['/service-car-services', 'svc.card.carservices.title'],
    ['/service-car-wash', 'svc.card.carwash.title']
  ];
  return (
<footer className="ftr">
    <div className="wrap">
      <div className="ftr-grid">
        <div>
          <span className="brand" style={{ padding: 0 }}>
        <BrandLockup locale={locale} />
      </span>
          <p className="ftr-blurb">{tx('ftr.blurb')}</p>
          <div className="emerg">
            <b>{tx('ftr.emergencyTitle')}</b>
            {tx('ftr.emergencyBody')}
          </div>
        </div>
  
        <div>
          <h3 className="ftr-h">{tx('ftr.services')}</h3>
          <ul>
            {SVC.map(([href, key]) => (
                      <li key={href}><a href={href}>{tx(key)}</a></li>
                    ))}
          </ul>
        </div>
  
        <div>
          <h3 className="ftr-h">{tx('ftr.company')}</h3>
          <ul>
            <li><a href="/about">{tx('ftr.about')}</a></li>
            <li><a href="/coverage">{tx('nav.coverage')}</a></li>
            <li><a href="/app">{tx('ftr.getApp')}</a></li>
            <li><a href="/providers">{tx('nav.providers')}</a></li>
            <li><a href="/contact">{tx('nav.contact')}</a></li>
          </ul>
        </div>
  
        <div>
          <h3 className="ftr-h">{tx('ftr.getInTouch')}</h3>
          <ul>
            <li><a href={`tel:${PHONE}`}>{PHONE_LABEL}</a></li>
            <li><a href={WA}>{tx('ftr.whatsappUs')}</a></li>
            <li><a href="mailto:support@basrecovery.com">support@basrecovery.com</a></li>
          </ul>
          {/* Hanya Facebook dan Instagram. Ikon X dan YouTube dibuang: kedua URL
              di situs lama (twitter.com/basrecovery, youtube.com/basrecovery)
              memberi 404 — akunnya tidak ada. Kembalikan begitu client mengirim
              handle yang benar. */}
          <div className="social" style={{ marginTop: 'var(--sp-5)' }}>
            <a href="https://www.facebook.com/basrecovery" aria-label="Bas Recovery on Facebook">
              <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M13.5 21v-8h2.7l.4-3h-3.1V8.3c0-.9.3-1.5 1.5-1.5h1.6V4.1A21 21 0 0 0 14.3 4C12 4 10.5 5.4 10.5 8v2H8v3h2.5v8h3Z" /></svg>
            </a>
            <a href="https://www.instagram.com/bas.recovery" aria-label="Bas Recovery on Instagram">
              <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 2.2c-2.7 0-3 0-4 .1-1.1 0-1.8.2-2.4.5a4 4 0 0 0-1.5 1A4 4 0 0 0 3 5.6c-.3.6-.4 1.3-.5 2.4 0 1-.1 1.3-.1 4s0 3 .1 4c0 1.1.2 1.8.5 2.4a4 4 0 0 0 1 1.5 4 4 0 0 0 1.5 1c.6.3 1.3.4 2.4.5 1 0 1.3.1 4 .1s3 0 4-.1c1.1 0 1.8-.2 2.4-.5a4.3 4.3 0 0 0 2.5-2.5c.3-.6.4-1.3.5-2.4 0-1 .1-1.3.1-4s0-3-.1-4c0-1.1-.2-1.8-.5-2.4a4 4 0 0 0-1-1.5 4 4 0 0 0-1.5-1c-.6-.3-1.3-.4-2.4-.5-1 0-1.3-.1-4-.1Zm0 1.8c2.7 0 2.9 0 4 .1.8 0 1.3.2 1.6.3.4.2.7.4 1 .6.2.3.4.6.6 1 .1.3.3.8.3 1.6.1 1.1.1 1.3.1 4s0 2.9-.1 4c0 .8-.2 1.3-.3 1.6-.2.4-.4.7-.6 1-.3.2-.6.4-1 .6-.3.1-.8.3-1.6.3-1.1.1-1.3.1-4 .1s-2.9 0-4-.1c-.8 0-1.3-.2-1.6-.3-.4-.2-.7-.4-1-.6-.2-.3-.4-.6-.6-1-.1-.3-.3-.8-.3-1.6-.1-1.1-.1-1.3-.1-4s0-2.9.1-4c0-.8.2-1.3.3-1.6.2-.4.4-.7.6-1 .3-.2.6-.4 1-.6.3-.1.8-.3 1.6-.3 1.1-.1 1.3-.1 4-.1Zm0 3.1a5 5 0 1 0 0 10 5 5 0 0 0 0-10Zm0 8.2a3.2 3.2 0 1 1 0-6.4 3.2 3.2 0 0 1 0 6.4Zm6.4-8.4a1.2 1.2 0 1 1-2.3 0 1.2 1.2 0 0 1 2.3 0Z" /></svg>
            </a>
          </div>
        </div>
      </div>
  
      <div className="ftr-base">
        <span>{tx('ftr.rights', { year: new Date().getFullYear() })}</span>
        <span className="sp" />
        <a href="/privacy">{tx('ftr.privacy')}</a>
        <a href="/terms">{tx('ftr.terms')}</a>
        <a href="/contact">{tx('ftr.support')}</a>
      </div>
    </div>
  </footer>
  );
};

/*
 * Figure situs publik.
 *
 * `photo` = nama dasar file di /images/site (mis. "recovery" → recovery-800.webp
 * + recovery-1600.webp). Kalau tidak diberi, komponen jatuh ke placeholder ikon
 * + caption seperti prototipe client — itu BUKAN kegagalan, itu cara menandai
 * slot yang fotonya belum ada dari client.
 *
 * Foto berasal dari situs lama (tabel Category/HomePage di prod), dipotong 3:2
 * dan diubah ke WebP dua ukuran, semuanya di bawah 120 KB sesuai anggaran paket.
 * Semua stok, bukan foto mitra sungguhan — client masih perlu mengirim yang asli.
 */
/*
 * `optional` untuk slot yang belum punya foto bawaan di public/images/site
 * (saat ini cuma coverage): tanpa timpaan dari dashboard ia tetap menampilkan
 * placeholder, bukan <img> yang 404.
 */
export const Figure = ({ photo, alt, caption, optional }) => {
  const name = photo && figureName(photo);
  const show = photo && !(optional && name === photo);
  return (
  <figure className="figure">
    {show
      ? <img
        src={`/images/site/${name}-1600.webp`}
        /* srcset lewat spread: React 16 memuntahkan `srcSet` apa adanya ke
           markup. Browser tidak peduli huruf besar, tapi alat audit mencari
           atribut huruf kecil — sama seperti kasus hreflang di Html.js. */
        {...{ srcset: `/images/site/${name}-800.webp 800w, /images/site/${name}-1600.webp 1600w` }}
        sizes="(max-width:1000px) 100vw, 46vw"
        alt={alt} loading="lazy" decoding="async" width="1600" height="1067"
      />
      : [
        <svg key="ph" className="ph" viewBox="0 0 24 24" aria-hidden="true">
          <path d="M3.5 5.5h17v13h-17z" /><circle cx="8" cy="10" r="1.6" /><path d="M20.5 15l-5-5-8 8.5" />
        </svg>,
        <figcaption key="cap">{caption}</figcaption>
      ]}
  </figure>
  );
};
